import './LoadingScreen.css';
import daisy from '../../media/Textures/Dogs/daisy.png';

function LoadingScreen() {
  return (
    <div className="LoadingScreen">
      <img src={daisy} alt="Loading..." className="loading-dog" />
      <p>Loading...</p>
    </div>
  );
}

export default LoadingScreen;